import * as React from 'react'
import propTypes from 'prop-types'
import { Box, Icon, Text } from '@deseretbook/react-ui'
import { Menu } from '../../../dbWebUI'
import { formatSecondsToTimeString } from '../../../utils/base'

import './ChapterListing.css'

/**
 * List of chapters.
 * @returns {function} Component
 */
export default function ChapterListing({ onSelectChapter, chapters, currentChapter }) {
  return (
    <Menu>
      <Menu.List>
        {chapters.map((selectedChapter, index) => {
          const timeString = formatSecondsToTimeString(selectedChapter.length)

          const timeStringMinutes = `${timeString.split(':')[0]}m`

          const isActive =
            currentChapter &&
            currentChapter.files &&
            currentChapter.files[0] &&
            currentChapter.files[0].checksum ===
              (selectedChapter.files &&
                selectedChapter.files[0] &&
                selectedChapter.files[0].checksum)

          return (
            <Menu.ListItem key={selectedChapter.name + selectedChapter.length}>
              <Menu.ListItem.Button
                id="chapter-listing-button"
                className={isActive ? 'is-active' : ''}
                onClick={() => onSelectChapter({ selectedChapter, index })}
              >
                <Box alignItems="center" justifyContent="space-between">
                  <Box alignItems="center">
                    {isActive && (
                      <Icon
                        style={{ width: '24px', height: '24px', marginRight: '0.5rem' }}
                        name="playing"
                      />
                    )}
                    <Text
                      style={{
                        fontFamily: 'Roboto, sans-serif',
                        fontSize: '14px',
                        fontWeight: isActive ? 700 : 400,
                        color: '#000000F2',
                      }}
                    >
                      {selectedChapter.name}
                    </Text>
                  </Box>
                  <Text
                    style={{
                      fontFamily: 'Roboto, sans-serif',
                      fontSize: '14px',
                      fontWeight: isActive ? 700 : 400,
                      color: isActive ? '#000000F2' : '#000000A6',
                    }}
                  >
                    {timeStringMinutes}
                  </Text>
                </Box>
              </Menu.ListItem.Button>
            </Menu.ListItem>
          )
        })}
      </Menu.List>
    </Menu>
  )
}

ChapterListing.propTypes = {
  onSelectChapter: propTypes.func,
  chapters: propTypes.arrayOf(propTypes.object),
  currentChapter: propTypes.shape({}),
}

ChapterListing.defaultProps = {
  onSelectChapter: () => {},
  chapters: [],
  currentChapter: null,
}
